import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Layout,
  Row
} from "antd";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SignLogo from "../../assets/images/logo-for-logins.png";
import apiPath from "../../constants/apiPath";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";

const { Content } = Layout;

// Key for localStorage
const REMEMBER_ME_KEY = "rememberedUser";

const SignIn = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { request } = useRequest();

  // Load saved credentials on component mount
  useEffect(() => {
    const savedCredentials = localStorage.getItem(REMEMBER_ME_KEY);
    if (savedCredentials) {
      try {
        const { email, password } = JSON.parse(savedCredentials);
        form.setFieldsValue({
          email,
          password,
          remember: true
        });
      } catch (error) {
        console.error("Error loading saved credentials:", error);
        // Clear corrupted data
        localStorage.removeItem(REMEMBER_ME_KEY);
      }
    }
  }, [form]);

  const onSubmit = (values) => {
    const { email, password, remember } = values;
    
    if (!email)
      return ShowToast("Please enter email to sign in", Severty.ERROR);

    const payload = { email, password };
    setLoading(true);
    
    request({
      url: apiPath.login,
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          // Handle remember me functionality
          if (remember) {
            // Save credentials to localStorage
            localStorage.setItem(REMEMBER_ME_KEY, JSON.stringify({ email, password }));
          } else {
            // Remove saved credentials if remember me is unchecked
            localStorage.removeItem(REMEMBER_ME_KEY);
          }
          
          ShowToast(data?.message, "success");
          navigate("/otp", { state: { email } });
        } else {
          ShowToast(data?.message || "Login failed", Severty.ERROR);
        }
      },
      onError: (error) => {
        console.log("Full error:", error);

        const backendMessage =
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.message ||
          "Something went wrong";

        setLoading(false);
        ShowToast(backendMessage, Severty.ERROR);
      },
    });
  };

  // Optional: Clear saved credentials manually
  const handleForgetPassword = () => {
    // You can choose to clear saved credentials when user goes to forgot password
    // localStorage.removeItem(REMEMBER_ME_KEY);
    navigate("/forgot-password");
  };

  return (
    <div className="main-new-login-page-designe-divv">
      <Layout className="layout-default layout-signin">
        <Content className="signin">
          <Row>
            <Col span={24} lg={24} className="contant-bg-sign">
              <div className="signin-box">
                <div className="signup-logo">
                  <img src={SignLogo}alt="Signin logo" />
                  <h4> Login To Your Account</h4>
                </div>

                <Form
                  form={form}
                  onFinish={onSubmit}
                  layout="vertical"
                  className="row-col"
                  initialValues={{
                    remember: false
                  }}
                >
                  <Form.Item
                    label="Email Address"
                    name="email"
                    rules={[
                      { required: true, message: "Please enter your email!" },
                      { type: "email", message: "Please enter a valid email!" },
                      {whitespace: true, message: "Email cannot be empty!"},
                    ]}
                  >
                    <Input placeholder="Enter Email Address" />
                  </Form.Item>

                  <Form.Item
                    label="Password"
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your password!",
                        
                      },
                      {whitespace: true, message: "Password cannot be empty!"},
                    ]}
                  >
                    <Input.Password placeholder="Enter Password" />
                  </Form.Item>

                  {/* Remember Me + Forgot Password */}
                  <Form.Item>
                    <Row
                      justify="space-between"
                      align="middle"
                      className="forget-password_new"
                    >
                      <Col>
                        <Form.Item
                          name="remember"
                          valuePropName="checked"
                          noStyle
                        >
                          <Checkbox>Remember Me</Checkbox>
                        </Form.Item>
                      </Col>
                      <Col>
                        <a onClick={handleForgetPassword} style={{ cursor: "pointer" }}>
                          Forgot Password?
                        </a>
                      </Col>
                    </Row>
                  </Form.Item>

                  <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading}>
                      Login
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </Col>
          </Row>
        </Content>
      </Layout>
    </div>
  );
};

export default SignIn;